import { useContext, useEffect, useState } from "react";
import { AuthenticationContext } from "../../components/authentication/AuthenticationContext";
import { HistoryTrack } from "../../types/HistoryTrack";
import callApi from "../../components/call-api/call-api";
import { Box, InputLabel, MenuItem, Select, Stack, Typography } from "@mui/material";
import React from "react";
import { getRecentTracks } from "../../components/apis/music-api";

const RecentTracks = () => {
    const { getAccessToken } = useContext(AuthenticationContext);
    const [ historyTracks, setHistoryTracks ] = useState<HistoryTrack[]>();
    const [ limit, setLimit ] = useState(10);

    const zeroPad = (num: number, places: number) => String(num).padStart(places, '0');
    const handleChange = (event: { target: { value: any; }; }) => setLimit(Number(event.target.value));
    
    useEffect(() => {
        callApi<HistoryTrack[]>(getRecentTracks(getAccessToken(), limit), setHistoryTracks);
    }, [getAccessToken, limit]);
    
    return (
        <>
            <Stack>
                <Box>
                    <Typography variant='h5'>Recent Listening History</Typography>
                </Box>
            </Stack>
            <Stack direction="row" sx={{ padding: '12px 0 12px 0' }}>
                <Box>
                    <InputLabel id="select-limit-label">Number of Results</InputLabel>
                    <Select
                        size="small"
                        value={limit}
                        onChange={handleChange}>
                        <MenuItem value="10">10</MenuItem>
                        <MenuItem value="20">20</MenuItem>
                        <MenuItem value="50">50</MenuItem>
                    </Select>
                </Box>
            </Stack>
            <Stack direction="column">
                {historyTracks?.map((historyTrack: HistoryTrack) =>
                    <Box sx={{ padding: '6px' }} key={`$history-track-${historyTrack.number}`}>
                        <Typography variant="body1" display="inline">{zeroPad(historyTrack.number, 2)}) </Typography>
                        <Typography variant="body1" display="inline" color="blue">{historyTrack.artistName}</Typography> - <Typography variant="body1" display="inline" color="green">{historyTrack.trackName}</Typography>
                    </Box>
                )}
            </Stack>
        </>
    )
}

export default RecentTracks;